module.exports = __webpack_public_path__ + "static/media/settings_active.b256fd8a.svg";